//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Config from "../Config/config";
export default {
  name: "enter",
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    // 登录
    onSubmit(values) {
      const bindInfo = sessionStorage.getItem("bindInfo") && JSON.parse(sessionStorage.getItem("bindInfo"));
      console.log(bindInfo);
      const {headimgurl , nickname , openid} = bindInfo
      const username = this.username.trim()
      const password = this.password
      let data = {
        username,
        password,
        openid,
        headimgurl,
        nickname,
      }
      this.$HTTP.HttpPost("/app/login/doLogin", data).then(res => {
        if (res.data.code === 200) {
            sessionStorage.setItem('token', res.data.data.token)
            this.$router.go(-2);
        }else{
          this.$vux.toast.show({
            text: res.data.msg,
            type: "text",
            width: "80%",
            isShowMask: true
          });
        }
      })
    },
  },
  created() {
   
  },
  mounted() {
    
  }
};



// WEBPACK FOOTER //
// ./src/components/enter.vue